module.exports = __webpack_public_path__ + "img/FactoryMap 2.5f8cd0e2.svg";